import { cn } from '../../lib/utils';

/** Device frame used by the widget preview pages. */
const PhoneMockup = ({ children, label, isDark = false, isRTL = false, className }) => (
  <div className="flex flex-col items-center gap-4">
    {label && <span className="text-sm font-medium text-muted-foreground">{label}</span>}
    <div
      className={cn(
        'relative w-[280px] h-[560px] rounded-[3rem] border-[8px] shadow-2xl overflow-hidden',
        isDark ? 'dark border-slate-800' : 'border-slate-900',
        className
      )}
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-28 h-6 bg-slate-900 rounded-b-2xl z-30" />
      <div
        className={cn(
          'w-full h-full relative overflow-hidden',
          isDark ? 'bg-slate-950' : 'bg-slate-50'
        )}
      >
        {children}
      </div>
      <div className="absolute bottom-2 left-1/2 -translate-x-1/2 w-24 h-1 bg-slate-400/40 rounded-full z-30" />
    </div>
  </div>
);

export default PhoneMockup;
